import { ComponentConfig, Slot } from '@measured/puck';

const DEFAULT_COLUMNS = 2;
const MIN_COLUMNS = 1;
const MAX_COLUMNS = 4;

type GridBlockProps = {
  columns: number;
  content: Slot;
};

const gridColMapping: Record<number, string> = {
  1: '',
  2: 'md:grid-cols-2',
  3: 'md:grid-cols-3',
  4: 'md:grid-cols-4',
};

const GridBlock: ComponentConfig<GridBlockProps> = {
  label: 'Grid',
  fields: {
    columns: {
      type: 'number',
      max: MAX_COLUMNS,
      min: MIN_COLUMNS,
    },
    content: {
      type: 'slot',
    },
  },
  defaultProps: {
    columns: DEFAULT_COLUMNS,
    content: [],
  },
  render: ({ columns, content: Content }) => {
    return <Content className={`grid grid-cols-1 ${gridColMapping[columns]} gap-4`} />;
  },
};

export { GridBlock };
